import React, {useRef, useEffect, useState} from "react";
import {
  VegaChip,
  VegaFlex,
  VegaDivider,
  VegaBox,
  VegaFont,
  VegaIcon
} from "@heartlandone/vega-react";
import dayjs from 'dayjs';
import defaultImage from "./assets/default-cover.png";

function DetailedItem({form = {}, isEdit = false}) {
  const containerRef = useRef(null);
  const [imgHeight, setImgHeight] = useState(0);

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver((entries) => {
      const width = entries[0].contentRect.width;
      setImgHeight(width / 2);
    });
    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);

  const formatAmount = (number) =>{
    if(number === '0' || number === null || number === undefined || number === '')
      return '0';
    else 
      return number;
  }; 
  const showCoverLink = () => {
      return window.coverUrl || defaultImage;
  }
  return (
    <VegaFlex
      className="v-rounded-12 "
      style={{
        backgroundColor: 'white',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        border: 'none',
      }}
      direction={"col"}
    >
      <VegaFlex ref={containerRef} direction="col">
        <img
          src={showCoverLink()}
          alt="cover"
          width="100%"
          height={imgHeight || "auto"}
          style={{
            borderRadius: "11px 11px 0 0",
            aspectRatio: "2 / 1",
            objectFit: 'cover'
          }}
        />
      </VegaFlex>
      <VegaBox direction={"col"} gap={"size-12"} className="v-rounded-12 v-p-size-16">
        <VegaFlex direction={"col"} gap={"size-16"}>
          <VegaFlex direction="row" justifyContent="space-between" alignItems="start">
            <div className="v-font-h6"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                flex: 1,
              }}
            >{form.title ? form?.title : "Activity"}</div>
            <VegaChip
              text=" New "
              size="extra-small"
              bgColor="bg-accent1-primary"
              statusColor="bg-slider-handle"
            />
          </VegaFlex>
          <VegaFlex>
            <VegaFont className="v-font-h1 v-text-success">{(form?.chargeType === 1 || formatAmount(form?.chargeAmount) === '0') ? 'Free' : '$' + formatAmount(form?.chargeAmount)}</VegaFont>
          </VegaFlex>
          <VegaFlex alignItems={"start"} gap={"size-12"}>
            <VegaChip
              text={form?.registerNumberLimitType === 'Unlimited' ? "Unlimited Participants" : formatAmount(form?.registerNumberLimit)}
              size="extra-small"
              bgColor="bg-chip"
              icon="fal fa-users"
            ></VegaChip>
          </VegaFlex>
        </VegaFlex>
        <VegaDivider margin={{ y: "size-16" }}></VegaDivider>
        <div style={{
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}>
          <VegaFlex gap="size-16" direction="col">
            <VegaFlex gap={"size-12"} alignItems="center">
              <VegaBox width="size-16" height="size-16">
                <VegaIcon
                  size="size-16"
                  icon="fal fa-clock"
                  color="text-secondary"
                ></VegaIcon>
              </VegaBox>
              <VegaFont color="text-secondary" variant="font-field-value-sm">
                {dayjs(form?.activityStartDate + (!!form?.activityStartTime ? ' ' + form?.activityStartTime : '')).format("MM/DD/YYYY, HH:mm")} -{" "}
                {dayjs(form?.activityEndDate + (!!form?.activityEndTime ? ' ' + form?.activityEndTime : '')).format("MM/DD/YYYY, HH:mm")}
              </VegaFont>
            </VegaFlex>
            <VegaFlex gap={"size-12"}>
              <VegaBox width="size-16" height="size-16" style={{textAlign: 'center'}}>
                <VegaIcon
                  icon={form?.isOnlineActivityText === 'online' ? "fal fa-presentation-screen" : "fal fa-location-dot"}
                  size="size-16"
                  color="text-secondary"
                ></VegaIcon>
              </VegaBox>
              <VegaFont color="text-secondary" variant="font-field-value-sm">
                {form?.isOnlineActivityText === 'online'  ? "Online Activity" : `${form?.city} - ${form?.address}`}
              </VegaFont>
            </VegaFlex>
          </VegaFlex>
        </div>
      </VegaBox>
    </VegaFlex>
  );
}

export default DetailedItem;
